module.exports = __webpack_public_path__ + "static/media/fi.0e5ef3f5.svg";